import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const freezeApi = api.injectEndpoints({
  endpoints: (build) => ({
    blockCard: build.mutation<
      ApiResponse<Partial<Card>>,
      {
        accountId: number;
        cardId: number;
      }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/block`,
        method: 'POST',
      }),
    }),
    unblockCard: build.mutation<
      ApiResponse<Partial<Card>>,
      {
        accountId: number;
        cardId: number;
      }
    >({
      query: ({ accountId, cardId }) => ({
        url: `private/river/${accountId}/card/${cardId}/unblock`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useBlockCardMutation, useUnblockCardMutation } = freezeApi;